import { exists } from '@engine/lib/utility/exists';
var DEFAULT_URL = 'https://example.com';

function populateUrlFieldsWithDefaultValue() {
  ['notification_url', 'return_success_url', 'return_cancel_url', 'return_failure_url', 'return_pending_url'].forEach(function (urlField) {
    var field = $("input[id$=\"".concat(urlField, "\"]"));

    if (!field.val()) {
      field.val("".concat(DEFAULT_URL, "/").concat(urlField));
    }
  });
}

function populateUrlField(urlType, urlPredefinedValue) {
  var urlField = $("input[id$='".concat(urlType, "']"));
  var urlValue = urlField.val();

  if (!urlValue || urlValue.includes(DEFAULT_URL)) {
    urlField.val(urlPredefinedValue);
  }
}

function clearUrls() {
  ['notification_url', 'return_success_url', 'return_cancel_url', 'return_failure_url', 'return_pending_url'].forEach(function (urlField) {
    $("input[id$=\"".concat(urlField, "\"]")).val('');
  });
}

function updateUrls(urls) {
  var urlTypes = Object.keys(urls);

  if (exists($('input[id$="_url"]'))) {
    populateUrlFieldsWithDefaultValue();
    urlTypes.forEach(function (urlType) {
      return populateUrlField(urlType, urls[urlType]);
    });
  }
}

var PreconfiguredUrls = {
  updateUrls: updateUrls,
  clearUrls: clearUrls
};
export default PreconfiguredUrls;